<template>
    <div class="welcome">
        <div class="quickly quickly-inner">
            <div class="btnList">
                <Permission allowed="data.customers.list">
                    <div class='items' @click="$router.push({path: '/data/customers/list'})">
                        <div>
                             <i class="iconfont">&#xe679;</i>
                        </div>
                        <span class="name">购房线索列表</span>
                    </div>
                </Permission>
                <Permission allowed="data.call-record.list">
                    <div class='items' @click="$router.push({path: '/data/phone/list'})">
                        <div>
                             <i class="iconfont">&#xe690;</i>
                        </div>
                        <span class="name">通话记录</span>
                    </div>
                </Permission>
                <Permission allowed="data.call-record.report">
                    <div class='items' @click="$router.push({path: '/data/phone/analysis'})">
                        <div>
                             <i class="iconfont">&#xe68f;</i>
                        </div>
                        <span class="name">通话记录统计</span>
                    </div>
                </Permission>
                <div class='items' @click="$router.push({path: '/data/investment/list'})">
                    <div>
                        <i class="iconfont">&#xe685;</i>
                    </div>
                    <span class="name">意向客户</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'DataWelcome'
}
</script>
<style scoped lang="less">
@import url('../../../assets/style/welcome.less');
</style>